import ColorService from 'Services/ColorService'
import {
  getMemberKeys,
  getUid,
} from 'Services/WeaverUtils'
import { getTypesMap } from './helpers'

const getColorByGraph = (nodes) => {
  const coloredNodes = {}
  _.forEach(nodes, (value, key) => {
    coloredNodes[key] = {
      ...value,
      color: value.graph ? ColorService.stringToPastelHex(value.graph) : '#EEEEEE'
    }
  }, {})

  return { nodes: coloredNodes }
}

const getColorByType = (nodes) => {
  const coloredNodes = {}
  _.forEach(nodes, (value, key) => {
    coloredNodes[key] = {
      ...value,
      color: value.type?.length > 0 ? ColorService.getColorForType(value.type[0].id) : '#EEEEEE'
    }
  }, {})

  return { nodes: coloredNodes }
}

const getTypes = (node) => {
  const typesMap = getTypesMap()
  const result = []
  const memberKeys = getMemberKeys()

  if (typesMap[getUid(node)]) {
    result.push(typesMap[getUid(node)])
  }

  memberKeys.forEach((memberKey) => {
    const relations = node.relation(memberKey).all()

    relations.forEach((t) => {
      if (t) {
        const id = getUid(t)
        result.push(typesMap[id])
      }
    })
  })

  return result
}

export {
  getColorByGraph,
  getColorByType,
  getTypes,
}
